module.exports = __webpack_public_path__ + "static/media/progman_44.c5ab8e3d.ico";